import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
  root: {
    minWidth: 200,
  },
  input: {
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 12,
    paddingRight: 12,
    fontSize: '0.875rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  inputOutline: {
    borderColor: `${theme.palette.text.hint}80 !important`,
  },
  calendarIcon: {
    color: theme.palette.text.secondary,
    marginRight: theme.spacing(0.5),
  },
  popoverPaper: {
    marginTop: theme.spacing(1),
    minWidth: 280,
    overflow: 'visible',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  gridContainer: {
    padding: theme.spacing(2),
    minHeight: 220,
  },
  monthButton: {
    minWidth: 0,
    padding: theme.spacing(1),
    fontSize: '0.8125rem',
  },
  monthButtonSelected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
  },
  yearButton: {
    minWidth: 0,
    padding: theme.spacing(1),
    fontSize: '0.8125rem',
  },
  yearButtonSelected: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
  },
}));
